import CommercialActiveUserTable from "./page/CommercialActiveUserTable";

const CommercialActiveUserReport:React.FC = () =>{
    return(
        <>
        <CommercialActiveUserTable/>
        </>
    )
};
export default CommercialActiveUserReport